module.exports = __webpack_public_path__ + "img/sp_foot_ico02_active.08a0e8c8.svg";